export const formatLargeNumber = (value: number) => {
  const thousand = 1000;
  const million = 1000000;

  const moreThanThousand = value / thousand >= 1;
  const moreThanMillion = value / million >= 1;

  if (moreThanMillion) return `${value / million} млн`;

  if (moreThanThousand) return `${value / thousand} тыс`;

  return value;
};
